import { useState, useRef } from "react";
import { reactionList } from "./data";
import styles from "./style.module.css";
import UseOutSideClick from "helpers/UseOutSideClick";
import { useSelector } from "react-redux";
import langData from "lang/data";

const ReviewModal = ({ showReviewModal, setShowReviewModal }) => {
  const [showReviewModalFirst, setShowReviewModalFirst] = useState(true);
  const [showReviewModalSecond, setShowReviewModalSecond] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);
  const [selectedReaction, setSelectedReaction] = useState(null);
  const [hover, setHover] = useState(null);
  const ContainerRef = useRef();
  const { currentLanguage } = useSelector(({ main }) => main);

  if (showReviewModal) {
    document.body.style.overflow = "hidden";
    setTimeout(() => {
      setShowAnimation(true);
    }, 200);
  } else {
    document.body.style.overflow = "auto";
    return;
  }

  const handlerSubmit = (e) => {
    e.preventDefault();
    if (selectedReaction) {
      setShowReviewModalFirst(false);
      setShowReviewModalSecond(true);
    } else {
      console.warn("error", e);
    }
  };

  const selectedReactionHendler = (reaction) => setSelectedReaction(reaction);

  UseOutSideClick(ContainerRef, () => {
    setShowReviewModal(false);
  });

  return (
    <div className={styles.background}>
      <div
        className={`${styles.container} ${
          showAnimation && styles.openedContainer
        }`}
        ref={ContainerRef}>
        <span
          className={styles.closeReviewModaleBtn}
          onClick={() => setShowReviewModal(!showReviewModal)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 32 32"
            fill="currentColor">
            <path
              d="M1 1L31 31M31 1L1 31"
              stroke="white"
              strokeWidth="2"
              fill="currentColor"
            />
          </svg>
        </span>
        <div
          className={styles.main}
          style={{ display: showReviewModalFirst ? "inline" : "none" }}>
          <div className={styles.headContent}>
            <p className={styles.modalTitle}>
              {langData?.reviewModal?.review_title[currentLanguage]}
            </p>
          </div>
          <div className={styles.modalBody}>
            <div className={styles.faces}>
              {reactionList.map((reaction) => (
                <span
                  key={reaction.id}
                  onClick={() => selectedReactionHendler(reaction)}
                  className={styles.reaction}
                  style={{
                    filter:
                      hover >= reaction.id ||
                      (selectedReaction && selectedReaction.id >= reaction.id)
                        ? "unset"
                        : "grayscale(100%)",
                  }}
                  onMouseEnter={() => {
                    setHover(reaction.id);
                  }}
                  onMouseLeave={() => {
                    selectedReaction && selectedReaction.id >= hover
                      ? setHover(reaction.id)
                      : setHover(null);
                  }}>
                  <img
                    height="64"
                    width="64"
                    src={reaction.src}
                  />
                </span>
              ))}
            </div>
            <div className={styles.reviewForm}>
              <form onSubmit={(e) => handlerSubmit(e)}>
                <textarea
                  className={styles.reviewFormTextarea}
                  id="reviewForm"
                  name="reviewForm"
                  rows="8"
                  cols="50"
                  placeholder={
                    langData?.reviewModal?.form[currentLanguage]
                  }></textarea>
                <button className={styles.submitButton}>
                  {langData?.reviewModal?.button_1[currentLanguage]}
                </button>
              </form>
            </div>
          </div>
        </div>

        <div
          className={styles.mainSecond}
          style={{ display: showReviewModalSecond ? "inline" : "none" }}>
          <div className={styles.headContent}>
            <p className={styles.modalTitle}>
              {langData?.reviewModal?.thanks_comment[currentLanguage]}
            </p>
          </div>
          <div className={styles.modalBody}>
            <div className={styles.vlvLogoModal}>
              <img src="https://vlv.am/public/logos/header_hy.svg" />
            </div>
            <div className={styles.popupBtn}>
              <button
                className={styles.submitButton}
                onClick={() => setShowReviewModal(!showReviewModal)}>
                {langData?.reviewModal?.button_2[currentLanguage]}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewModal;
